import { SxProps, Theme } from "@mui/material";

export const gradientText: SxProps<Theme> = {
  background: "linear-gradient(90deg, #3b82f6 0%, #38bdf8 60%, #67e8f9 100%)",
  WebkitBackgroundClip: "text",
  WebkitTextFillColor: "transparent",
  backgroundClip: "text",
};

export const heroSection: SxProps<Theme> = {
  position: "relative",
  overflow: "hidden",
  color: "white",
  minHeight: { xs: "auto", md: "100vh" },
  display: "flex",
  alignItems: "center",
  py: { xs: 12, md: 0 },
  background: "linear-gradient(to bottom, #000000, #080c14)",
};

export const heroVideoOverlay: SxProps<Theme> = {
  position: "absolute",
  top: 0,
  left: 0,
  width: "100%",
  height: "100%",
  background: "rgba(8,12,20,0.28)",
  zIndex: 1,
};

export const heroRadialOverlay: SxProps<Theme> = {
  position: "absolute",
  top: 0,
  left: 0,
  width: "100%",
  height: "100%",
  background: "radial-gradient(ellipse 75% 65% at 50% 50%, rgba(0,0,0,0.72) 0%, rgba(0,0,0,0) 75%)",
  zIndex: 1,
};

export const heroTopGradient: SxProps<Theme> = {
  position: "absolute",
  top: 0,
  left: 0,
  width: "100%",
  height: "25%",
  background: "linear-gradient(to bottom, rgba(5,10,28,0.20) 0%, rgba(5,10,28,0) 100%)",
  zIndex: 2,
  pointerEvents: "none",
};

export const heroEyebrow: SxProps<Theme> = {
  mb: 4,
  fontSize: { xs: "0.7rem", md: "0.75rem" },
  fontWeight: 600,
  letterSpacing: "0.2em",
  textTransform: "uppercase",
  color: "#38bdf8",
  fontFamily: "'Barlow', sans-serif",
  opacity: 0,
  animation: "fadeUp 0.7s ease forwards",
  animationDelay: "0s",
  "@keyframes fadeUp": {
    from: { opacity: 0, transform: "translateY(28px)" },
    to: { opacity: 1, transform: "translateY(0)" },
  },
};

export const heroHeadlineWhite: SxProps<Theme> = {
  fontSize: { xs: "4.5rem", md: "7rem", lg: "9rem" },
  letterSpacing: "-0.03em",
  lineHeight: 0.95,
  fontWeight: 800,
  color: "white",
  mb: 0,
  opacity: 0,
  animation: "fadeUp 0.7s ease forwards",
  animationDelay: "0.2s",
};

export const heroHeadlineGradient: SxProps<Theme> = {
  fontSize: { xs: "4.5rem", md: "7rem", lg: "9rem" },
  letterSpacing: "-0.03em",
  lineHeight: 0.95,
  fontWeight: 800,
  mb: 5,
  pb: "0.18em",
  background: "linear-gradient(90deg, #3b82f6 0%, #38bdf8 60%, #67e8f9 100%)",
  WebkitBackgroundClip: "text",
  WebkitTextFillColor: "transparent",
  backgroundClip: "text",
  opacity: 0,
  animation: "fadeUp 0.7s ease forwards",
  animationDelay: "0.4s",
};

export const heroBody: SxProps<Theme> = {
  mb: 6,
  fontWeight: 400,
  color: "rgba(255,255,255,0.82)",
  lineHeight: 1.65,
  fontSize: { xs: "1rem", md: "1.15rem" },
  maxWidth: 620,
  mx: "auto",
  fontFamily: "'Barlow', sans-serif",
  opacity: 0,
  animation: "fadeUp 0.7s ease forwards",
  animationDelay: "0.6s",
};

export const heroCtaRow: SxProps<Theme> = {
  display: "flex",
  gap: 2,
  flexWrap: "wrap",
  justifyContent: "center",
  opacity: 0,
  animation: "fadeUp 0.7s ease forwards",
  animationDelay: "0.8s",
};

export const heroScrollIndicator: SxProps<Theme> = {
  position: "absolute",
  bottom: 25,
  left: "50%",
  transform: "translateX(-50%)",
  zIndex: 3,
  display: "flex",
  flexDirection: "column",
  alignItems: "center",
  gap: 0.75,
  cursor: "pointer",
  "@keyframes float": {
    "0%, 100%": { transform: "translateX(-50%) translateY(0)" },
    "50%": { transform: "translateX(-50%) translateY(-8px)" },
  },
  animation: "float 2.4s ease-in-out infinite",
  "&:hover": { opacity: 0.7 },
  transition: "opacity 0.2s",
};

export const heroScrollLabel: SxProps<Theme> = {
  fontSize: "0.65rem",
  fontWeight: 600,
  letterSpacing: "0.18em",
  textTransform: "uppercase",
  color: "rgba(255,255,255,0.65)",
  fontFamily: "'Barlow', sans-serif",
};

export const heroBottomFade: SxProps<Theme> = {
  position: "absolute",
  bottom: 0,
  left: 0,
  width: "100%",
  height: "200px",
  background: "linear-gradient(to bottom, transparent, #080c14)",
  zIndex: 2,
  pointerEvents: "none",
};

export const zipQuoteForm: SxProps<Theme> = {
  display: "flex",
  alignItems: "center",
  gap: 0,
  maxWidth: "100%",
};

export const zipQuoteInput: SxProps<Theme> = {
  flex: 1,
  minWidth: 0,
  height: 52,
  px: "20px",
  fontSize: "1rem",
  fontFamily: "'Barlow', sans-serif",
  color: "#0a0f1e",
  background: "white",
  border: "none",
  borderRadius: "50px 0 0 50px",
  outline: "none",
  "&::placeholder": { color: "rgba(10,15,30,0.4)" },
  "&:focus": { background: "white" },
};

export const zipQuoteButton: SxProps<Theme> = {
  height: 52,
  px: { xs: "16px", sm: "24px" },
  fontSize: { xs: "0.85rem", sm: "1rem" },
  fontWeight: 700,
  fontFamily: "'Barlow', sans-serif",
  color: "white",
  background: "linear-gradient(90deg, #f97316 0%, #fb923c 100%)",
  border: "none",
  borderRadius: "0 50px 50px 0",
  cursor: "pointer",
  whiteSpace: "nowrap",
  flexShrink: 0,
  transition: "opacity 0.2s ease",
  "&:hover": { opacity: 0.88 },
};

export const productsSectionOuter: SxProps<Theme> = {
  background: "linear-gradient(to bottom, #080c14, #0d1526)",
  minHeight: { xs: "auto", md: "100vh" },
  display: "flex",
  flexDirection: "column",
};

export const productsSectionContent: SxProps<Theme> = {
  flex: 1,
  display: "flex",
  alignItems: "center",
  py: { xs: 8, md: 10 },
};

export const productsEyebrow: SxProps<Theme> = {
  mb: 3,
  fontSize: { xs: "0.7rem", md: "0.75rem" },
  fontWeight: 600,
  letterSpacing: "0.2em",
  textTransform: "uppercase",
  color: "#38bdf8",
  fontFamily: "'Barlow', sans-serif",
  opacity: 0,
  "@keyframes copySlideIn": {
    from: { opacity: 0, transform: "translateX(-24px)" },
    to: { opacity: 1, transform: "translateX(0)" },
  },
};

export const productsHeadline: SxProps<Theme> = {
  fontSize: { xs: "3rem", md: "4.5rem", lg: "5.5rem" },
  letterSpacing: "-0.03em",
  lineHeight: 1.1,
  fontWeight: 800,
  mb: 4,
  opacity: 0,
};

export const productsBody: SxProps<Theme> = {
  mb: 6,
  fontWeight: 400,
  color: "rgba(255,255,255,0.82)",
  lineHeight: 1.65,
  fontSize: { xs: "1rem", md: "1.15rem" },
  fontFamily: "'Barlow', sans-serif",
  maxWidth: 520,
  opacity: 0,
};

export const specCard: SxProps<Theme> = {
  pt: 3,
  pr: { xs: 0, sm: 3 },
  borderTop: "1px solid rgba(59,130,246,0.25)",
};

export const specNumber: SxProps<Theme> = {
  fontSize: { xs: "2.5rem", md: "3rem" },
  fontWeight: 800,
  lineHeight: 1,
  mb: 0.75,
  background: "linear-gradient(90deg, #3b82f6 0%, #38bdf8 60%, #67e8f9 100%)",
  WebkitBackgroundClip: "text",
  WebkitTextFillColor: "transparent",
  backgroundClip: "text",
};

export const specLabel: SxProps<Theme> = {
  fontSize: "0.7rem",
  fontWeight: 700,
  letterSpacing: "0.15em",
  textTransform: "uppercase",
  color: "white",
  mb: 0.5,
};

export const specDescription: SxProps<Theme> = {
  fontSize: "0.8rem",
  color: "rgba(255,255,255,0.82)",
  lineHeight: 1.5,
  fontFamily: "'Barlow', sans-serif",
};

export const productImageContainer: SxProps<Theme> = {
  position: "relative",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  minHeight: { xs: 280, md: 480 },
};

export const productImageGlow: SxProps<Theme> = {
  position: "absolute",
  width: "70%",
  height: "70%",
  borderRadius: "50%",
  background:
    "radial-gradient(ellipse at center, rgba(56,189,248,0.18) 0%, rgba(59,130,246,0.08) 50%, transparent 75%)",
  filter: "blur(40px)",
  pointerEvents: "none",
};

export const productImage: SxProps<Theme> = {
  position: "relative",
  zIndex: 1,
  maxWidth: { xs: "75%", md: "85%" },
  maxHeight: { xs: 260, md: 460 },
  objectFit: "contain",
  filter: "drop-shadow(0 0 40px rgba(56,189,248,0.25))",
};

export const slideControls: SxProps<Theme> = {
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  gap: 2,
  mt: { xs: 6, md: 8 },
};

export const slideNavButton = (disabled: boolean): SxProps<Theme> => ({
  color: disabled ? "rgba(255,255,255,0.15)" : "rgba(255,255,255,0.6)",
  border: "1px solid",
  borderColor: disabled ? "rgba(255,255,255,0.08)" : "rgba(255,255,255,0.2)",
  borderRadius: "50%",
  p: 1,
  "&:hover": {
    borderColor: "rgba(56,189,248,0.5)",
    color: "#38bdf8",
    bgcolor: "transparent",
  },
});

export const slideDot = (isActive: boolean): SxProps<Theme> => ({
  width: isActive ? 24 : 8,
  height: 8,
  borderRadius: "4px",
  bgcolor: isActive ? "#38bdf8" : "rgba(255,255,255,0.2)",
  cursor: "pointer",
  transition: "width 0.3s ease, background-color 0.3s ease",
  "&:hover": {
    bgcolor: isActive ? "#38bdf8" : "rgba(255,255,255,0.4)",
  },
});

export const socialProofSection: SxProps<Theme> = {
  position: "relative",
  overflow: "hidden",
  py: { xs: 10, md: 14 },
  background: "linear-gradient(to bottom, #0d1526, #080c14)",
  display: "flex",
  alignItems: "center",
};

export const socialProofEyebrow: SxProps<Theme> = {
  color: "#38bdf8",
  fontSize: "0.72rem",
  fontWeight: 600,
  letterSpacing: "0.22em",
  textTransform: "uppercase",
  mb: 2,
  opacity: 0,
  "@keyframes fadeUp": {
    from: { opacity: 0, transform: "translateY(28px)" },
    to: { opacity: 1, transform: "translateY(0)" },
  },
};

export const socialProofHeadline: SxProps<Theme> = {
  fontFamily: "'Poppins', sans-serif",
  fontWeight: 800,
  fontSize: { xs: "3rem", md: "5rem", lg: "6.5rem" },
  lineHeight: 1.05,
  color: "white",
  letterSpacing: "-0.03em",
  mb: 3,
  opacity: 0,
};

export const socialProofBody: SxProps<Theme> = {
  fontFamily: "'Barlow', sans-serif",
  color: "rgba(255,255,255,0.82)",
  fontSize: { xs: "1rem", md: "1.1rem" },
  lineHeight: 1.7,
  maxWidth: 580,
  mx: "auto",
  mb: { xs: 8, md: 10 },
  opacity: 0,
};

export const statCard: SxProps<Theme> = {
  position: "relative",
  overflow: "hidden",
  background: "linear-gradient(135deg, rgba(255,255,255,0.05) 0%, rgba(255,255,255,0.02) 100%)",
  backdropFilter: "blur(12px)",
  border: "1px solid rgba(255,255,255,0.09)",
  borderRadius: "16px",
  p: { xs: 4, md: 5 },
  textAlign: "center",
  transition: "all 0.3s ease",
  opacity: 0,
  "@keyframes cardEntrance": {
    "0%": { opacity: 0, transform: "translateY(40px) scale(0.92)" },
    "60%": { opacity: 1 },
    "100%": { opacity: 1, transform: "translateY(0) scale(1)" },
  },
  "&:hover": {
    transform: "translateY(-4px)",
    border: "1px solid rgba(56,189,248,0.25)",
    boxShadow: "0 20px 60px rgba(0,0,0,0.4), 0 0 40px rgba(56,189,248,0.08)",
  },
};

export const statCardTopBar: SxProps<Theme> = {
  position: "absolute",
  top: 0,
  left: 0,
  width: "100%",
  height: "4px",
  background: "linear-gradient(90deg, #3b82f6, #38bdf8, #67e8f9)",
  borderRadius: "16px 16px 0 0",
};

export const statCardGlow: SxProps<Theme> = {
  position: "absolute",
  top: -40,
  left: "50%",
  transform: "translateX(-50%)",
  width: 160,
  height: 160,
  borderRadius: "50%",
  background: "radial-gradient(circle, rgba(56,189,248,0.12) 0%, transparent 70%)",
  pointerEvents: "none",
  filter: "blur(24px)",
};

export const statCardValue: SxProps<Theme> = {
  fontFamily: "'Poppins', sans-serif",
  fontWeight: 800,
  fontSize: { xs: "3rem", md: "3.8rem" },
  background: "linear-gradient(90deg, #3b82f6 0%, #38bdf8 60%, #67e8f9 100%)",
  WebkitBackgroundClip: "text",
  WebkitTextFillColor: "transparent",
  backgroundClip: "text",
  lineHeight: 1,
  mb: 1.5,
};

export const statCardLabel: SxProps<Theme> = {
  fontFamily: "'Barlow', sans-serif",
  color: "rgba(255,255,255,0.72)",
  fontSize: "0.8rem",
  fontWeight: 600,
  letterSpacing: "0.12em",
  textTransform: "uppercase",
};

export const financingSection: SxProps<Theme> = {
  py: { xs: 8, md: 12 },
  background: "linear-gradient(to bottom, #080c14, #0a0f1e)",
};

export const financingDivider: SxProps<Theme> = {
  height: "1px",
  background: "linear-gradient(to right, transparent, rgba(255,255,255,0.05), transparent)",
  mb: { xs: 8, md: 12 },
  mt: { xs: -8, md: -12 },
};

export const financingEyebrow: SxProps<Theme> = {
  mb: 3,
  fontSize: { xs: "0.7rem", md: "0.75rem" },
  fontWeight: 600,
  letterSpacing: "0.2em",
  textTransform: "uppercase",
  color: "#38bdf8",
  fontFamily: "'Barlow', sans-serif",
};

export const financingHeadline: SxProps<Theme> = {
  mb: 3,
  fontWeight: 800,
  fontSize: { xs: "3rem", md: "4.5rem", lg: "5.5rem" },
  letterSpacing: "-0.03em",
  lineHeight: 1.05,
  color: "white",
};

export const financingBody: SxProps<Theme> = {
  mb: 6,
  fontWeight: 400,
  color: "rgba(255,255,255,0.82)",
  lineHeight: 1.65,
  fontSize: { xs: "1rem", md: "1.15rem" },
  fontFamily: "'Barlow', sans-serif",
  maxWidth: 580,
  mx: "auto",
};

export const financingFinePrint: SxProps<Theme> = {
  mb: 3,
  color: "rgba(255,255,255,0.82)",
  fontSize: { xs: "1rem", md: "1.15rem" },
  fontFamily: "'Barlow', sans-serif",
  lineHeight: 1.65,
};

export const technologyStickyContainer: SxProps<Theme> = {
  position: { xs: "relative", md: "sticky" },
  top: { md: 64 },
  height: { xs: "auto", md: "calc(100vh - 64px)" },
  display: "flex",
  flexDirection: { xs: "column", md: "row" },
  overflow: "hidden",
  background: "#0a0f1e",
};

export const technologyLeftPanel: SxProps<Theme> = {
  width: { xs: "100%", md: "50%" },
  display: "flex",
  alignItems: "center",
  px: { xs: 3, md: 8 },
  py: { xs: 8, md: 0 },
  overflow: "hidden",
};

export const technologyEyebrow: SxProps<Theme> = {
  fontSize: "0.75rem",
  fontWeight: 600,
  letterSpacing: "0.2em",
  color: "#38bdf8",
  fontFamily: "'Barlow', sans-serif",
  mb: 2,
  textTransform: "uppercase",
};

export const technologyHeadline: SxProps<Theme> = {
  fontSize: { xs: "2.6rem", md: "3.6rem", lg: "4.4rem" },
  letterSpacing: "-0.02em",
  lineHeight: 1.15,
  fontWeight: 800,
  mb: 3,
};

export const technologyBody: SxProps<Theme> = {
  color: "rgba(255,255,255,0.82)",
  fontSize: "1.1rem",
  lineHeight: 1.65,
  fontFamily: "'Barlow', sans-serif",
  mb: 4,
};

export const technologyFeatureCheckIcon: SxProps<Theme> = {
  width: 22,
  height: 22,
  borderRadius: "50%",
  background: "rgba(59,130,246,0.15)",
  border: "1px solid rgba(59,130,246,0.4)",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  flexShrink: 0,
  mt: "2px",
  boxShadow: "0 0 10px rgba(59,130,246,0.35)",
};

export const technologyFeatureTitle: SxProps<Theme> = {
  color: "white",
  fontSize: "1.125rem",
  fontWeight: 700,
  fontFamily: "'Barlow', sans-serif",
  lineHeight: 1.3,
  mb: 0.4,
};

export const technologyFeatureDescription: SxProps<Theme> = {
  color: "rgba(255,255,255,0.75)",
  fontSize: "1rem",
  fontFamily: "'Barlow', sans-serif",
  lineHeight: 1.5,
};

export const technologyRightPanel: SxProps<Theme> = {
  display: { xs: "none", md: "block" },
  width: "50%",
  position: "relative",
  overflow: "hidden",
};

export const technologyMobileImage: SxProps<Theme> = {
  display: { xs: "block", md: "none" },
  width: "100%",
  px: 4,
  pb: 8,
};

export const technologyImageGlow: SxProps<Theme> = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: "100%",
  height: "100%",
  background:
    "radial-gradient(ellipse at center, rgba(59,130,246,0.22) 0%, rgba(56,189,248,0.12) 40%, transparent 72%)",
  pointerEvents: "none",
  zIndex: 0,
  filter: "blur(50px)",
};

export const technologyFrame: SxProps<Theme> = {
  position: "absolute",
  top: "50%",
  left: "50%",
  width: "100%",
  willChange: "opacity, transform",
  zIndex: 1,
};

export const technologyFrameImage: SxProps<Theme> = {
  display: "block",
  width: "100%",
  maxHeight: "94vh",
  borderRadius: "12px",
  boxShadow: "0 32px 100px rgba(0,0,0,0.9), 0 0 80px rgba(59,130,246,0.1)",
  userSelect: "none",
  pointerEvents: "none",
};

export const technologyCarouselRow: SxProps<Theme> = {
  display: "flex",
  flexDirection: { xs: "column", md: "row" },
  alignItems: "center",
  gap: { xs: 8, md: 10 },
};

export const technologyCarouselControls: SxProps<Theme> = {
  display: "flex",
  justifyContent: "flex-end",
  gap: 1,
  mb: 2,
};

export const technologyCarouselArrow: SxProps<Theme> = {
  width: 40,
  height: 40,
  borderRadius: "50%",
  background: "rgba(255,255,255,0.07)",
  border: "1px solid rgba(255,255,255,0.15)",
  color: "white",
  "&:hover": {
    background: "rgba(56,189,248,0.2)",
    border: "1px solid rgba(56,189,248,0.4)",
  },
};

export const technologyCarouselImage: SxProps<Theme> = {
  display: "block",
  width: "100%",
  borderRadius: "12px",
  boxShadow: "0 32px 100px rgba(0,0,0,0.9), 0 0 80px rgba(59,130,246,0.1)",
  userSelect: "none",
};

export const technologyCarouselDots: SxProps<Theme> = {
  display: "flex",
  justifyContent: "center",
  gap: "8px",
  mt: 3,
};

export const technologyCarouselDot: SxProps<Theme> = {
  width: 8,
  height: 8,
  borderRadius: "50%",
  cursor: "pointer",
  transition: "background 0.3s ease",
};

export const appSection: SxProps<Theme> = {
  background: "linear-gradient(to bottom, #0a0f1e, #050c23)",
  py: { xs: 12, md: 18 },
  display: "flex",
  flexDirection: { xs: "column", md: "row" },
  alignItems: "center",
  overflow: "hidden",
  position: "relative",
};

export const appSectionGlow: SxProps<Theme> = {
  position: "absolute",
  left: 0,
  top: "10%",
  width: "60%",
  height: "80%",
  background:
    "radial-gradient(ellipse 60% 70% at 25% 50%, rgba(56,189,248,0.07) 0%, rgba(59,130,246,0.04) 40%, transparent 70%)",
  pointerEvents: "none",
  zIndex: 0,
};

export const appMockupImage: SxProps<Theme> = {
  width: "100%",
  height: "100%",
  objectFit: "cover",
  objectPosition: "left center",
  display: "block",
};

export const appRightContent: SxProps<Theme> = {
  flex: 1,
  pl: { xs: 4, md: 8, lg: 12 },
  pr: { xs: 4, md: 6 },
  py: { xs: 6, md: 0 },
  position: "relative",
  zIndex: 1,
};

export const appEyebrow: SxProps<Theme> = {
  fontSize: "0.7rem",
  fontWeight: 600,
  letterSpacing: "0.2em",
  textTransform: "uppercase",
  color: "#38bdf8",
  fontFamily: "'Barlow', sans-serif",
  mb: 3,
};

export const appHeadline: SxProps<Theme> = {
  fontWeight: 800,
  fontSize: { xs: "2.5rem", md: "3.2rem" },
  letterSpacing: "-0.02em",
  lineHeight: 1.15,
  mb: 2,
};

export const appBodyText: SxProps<Theme> = {
  fontFamily: "'Barlow', sans-serif",
  color: "rgba(255,255,255,0.82)",
  fontSize: { xs: "1rem", md: "1.1rem" },
  lineHeight: 1.7,
  mb: 0,
  maxWidth: 480,
};

export const appCardBox: SxProps<Theme> = {
  background: "rgba(255,255,255,0.04)",
  border: "1px solid rgba(255,255,255,0.08)",
  borderRadius: "16px",
  backdropFilter: "blur(12px)",
  p: 3,
  height: "100%",
  cursor: "default",
};

export const appCardIcon: SxProps<Theme> = {
  display: "inline-flex",
  background: "rgba(56,189,248,0.12)",
  color: "#38bdf8",
  borderRadius: "10px",
  p: 1,
  mb: 1.5,
};

export const appCardTitle: SxProps<Theme> = {
  fontFamily: "'Poppins', sans-serif",
  fontWeight: 700,
  color: "white",
  fontSize: "1rem",
  mb: 0.5,
};

export const appCardDescription: SxProps<Theme> = {
  fontFamily: "'Barlow', sans-serif",
  color: "rgba(255,255,255,0.82)",
  fontSize: "0.9rem",
  lineHeight: 1.6,
};

export const appStoreBadge: SxProps<Theme> = {
  mt: 4,
  display: "inline-flex",
  alignItems: "center",
  px: 2,
  py: 0.75,
  borderRadius: "100px",
  border: "1px solid rgba(255,255,255,0.15)",
  background: "rgba(255,255,255,0.06)",
  backdropFilter: "blur(8px)",
};

export const appStoreBadgeText: SxProps<Theme> = {
  fontFamily: "'Barlow', sans-serif",
  fontSize: "0.7rem",
  fontWeight: 600,
  letterSpacing: "0.15em",
  textTransform: "uppercase",
  color: "rgba(255,255,255,0.5)",
};

export const howItWorksSection: SxProps<Theme> = {
  py: { xs: 10, md: 16 },
  position: "relative",
  backgroundImage: "url('/img/assets/hero (1).png')",
  backgroundSize: "cover",
  backgroundPosition: "center",
  backgroundRepeat: "no-repeat",
};

export const howItWorksRadialOverlay: SxProps<Theme> = {
  position: "absolute",
  inset: 0,
  background:
    "radial-gradient(ellipse 75% 85% at 50% 50%, rgba(10,15,30,0.55) 0%, rgba(10,15,30,0.2) 50%, rgba(10,15,30,0.0) 100%)",
  zIndex: 0,
};

export const howItWorksTopFade: SxProps<Theme> = {
  position: "absolute",
  top: 0,
  left: 0,
  right: 0,
  height: "280px",
  background: "linear-gradient(to bottom, #0a0f1e 0%, transparent 100%)",
  zIndex: 1,
  pointerEvents: "none",
};

export const howItWorksBottomFade: SxProps<Theme> = {
  position: "absolute",
  bottom: 0,
  left: 0,
  right: 0,
  height: "180px",
  background: "linear-gradient(to top, #0a0f1e 0%, transparent 100%)",
  zIndex: 1,
  pointerEvents: "none",
};

export const howItWorksEyebrow: SxProps<Theme> = {
  fontSize: "0.7rem",
  fontWeight: 700,
  letterSpacing: "0.2em",
  textTransform: "uppercase",
  color: "#38bdf8",
  fontFamily: "'Barlow', sans-serif",
  mb: 2,
};

export const howItWorksHeadline: SxProps<Theme> = {
  color: "white",
  fontWeight: 800,
  fontSize: { xs: "2.5rem", md: "3.5rem" },
  letterSpacing: "-0.02em",
  lineHeight: 1.15,
  mb: 2,
};

export const howItWorksSubtitle: SxProps<Theme> = {
  color: "rgba(255,255,255,0.82)",
  fontSize: { xs: "1.1rem", md: "1.2rem" },
  fontFamily: "'Barlow', sans-serif",
};

export const howItWorksCarousel: SxProps<Theme> = {
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  gap: { xs: 1, md: 3 },
};

export const howItWorksNavButton = (disabled: boolean): SxProps<Theme> => ({
  color: disabled ? "rgba(255,255,255,0.2)" : "#38bdf8",
  border: "1px solid",
  borderColor: disabled ? "rgba(255,255,255,0.1)" : "rgba(56,189,248,0.4)",
  width: 44,
  height: 44,
  flexShrink: 0,
  boxShadow: disabled ? "none" : "0 0 12px rgba(56,189,248,0.35), 0 0 24px rgba(56,189,248,0.15)",
  "&:hover": {
    background: "rgba(56,189,248,0.08)",
    boxShadow: "0 0 18px rgba(56,189,248,0.55), 0 0 36px rgba(56,189,248,0.25)",
  },
  "&.Mui-disabled": {
    color: "rgba(255,255,255,0.2)",
  },
});

export const howItWorksCarouselViewport: SxProps<Theme> = {
  flex: 1,
  overflow: "hidden",
  position: "relative",
  height: { xs: 280, md: 320 },
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
};

export const howItWorksStepNumber: SxProps<Theme> = {
  fontSize: "0.8rem",
  fontWeight: 600,
  letterSpacing: "0.15em",
  fontFamily: "'Barlow', sans-serif",
  mb: 1,
  textTransform: "uppercase",
};

export const howItWorksStepTitle: SxProps<Theme> = {
  color: "white",
  fontWeight: 700,
  fontSize: { xs: "1.15rem", md: "1.25rem" },
  lineHeight: 1.3,
  mb: 1.5,
  fontFamily: "'Barlow', sans-serif",
};

export const howItWorksStepDescription: SxProps<Theme> = {
  color: "rgba(255,255,255,0.65)",
  fontSize: "1rem",
  lineHeight: 1.6,
  fontFamily: "'Barlow', sans-serif",
};

export const howItWorksDot = (isActive: boolean): SxProps<Theme> => ({
  width: isActive ? 24 : 8,
  height: 8,
  borderRadius: "4px",
  background: isActive ? "#38bdf8" : "rgba(255,255,255,0.2)",
  transition: "background 0.4s ease, width 0.4s ease",
  cursor: "pointer",
});

export const howItWorksZipForm: SxProps<Theme> = {
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  gap: 0,
  mt: 6,
  maxWidth: 480,
  mx: "auto",
};

export const testimonialsSection: SxProps<Theme> = {
  position: "relative",
  width: "100%",
  height: { xs: "100svh", md: "90vh" },
  minHeight: { xs: 560, md: 680 },
  overflow: "hidden",
};

export const testimonialIframe: SxProps<Theme> = {
  position: "absolute",
  top: 0,
  left: 0,
  width: "100%",
  height: "100%",
  border: "none",
  zIndex: 2,
};

export const testimonialCloseButton: SxProps<Theme> = {
  position: "absolute",
  top: 16,
  right: 16,
  zIndex: 3,
  width: 40,
  height: 40,
  borderRadius: "50%",
  background: "rgba(0,0,0,0.6)",
  backdropFilter: "blur(6px)",
  border: "1px solid rgba(255,255,255,0.2)",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  cursor: "pointer",
  transition: "background 0.2s ease",
  "&:hover": { background: "rgba(0,0,0,0.85)" },
};

export const testimonialGradientTop: SxProps<Theme> = {
  position: "absolute",
  inset: 0,
  background: "linear-gradient(to top, rgba(0,0,0,0.92) 0%, rgba(0,0,0,0.35) 50%, rgba(0,0,0,0.15) 100%)",
  pointerEvents: "none",
};

export const testimonialGradientLeft: SxProps<Theme> = {
  position: "absolute",
  inset: 0,
  background: "linear-gradient(to right, rgba(0,0,0,0.55) 0%, transparent 60%)",
  pointerEvents: "none",
};

export const testimonialPlayOverlay: SxProps<Theme> = {
  position: "absolute",
  inset: 0,
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  cursor: "pointer",
  "&:hover .play-btn": {
    transform: "scale(1.1)",
    backgroundColor: "rgba(255,255,255,0.22)",
  },
};

export const testimonialPlayButton: SxProps<Theme> = {
  width: { xs: 68, md: 88 },
  height: { xs: 68, md: 88 },
  borderRadius: "50%",
  border: "2px solid rgba(255,255,255,0.85)",
  backdropFilter: "blur(10px)",
  backgroundColor: "rgba(255,255,255,0.12)",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  transition: "transform 0.3s ease, background-color 0.3s ease",
};

export const testimonialInfoBox: SxProps<Theme> = {
  position: "absolute",
  bottom: { xs: 32, md: 52 },
  left: { xs: 24, md: 52 },
  maxWidth: { xs: "calc(100% - 48px)", md: "50%" },
};

export const testimonialSectionEyebrow: SxProps<Theme> = {
  color: "#38bdf8",
  fontSize: { xs: "0.65rem", md: "0.72rem" },
  fontWeight: 600,
  letterSpacing: "0.18em",
  textTransform: "uppercase",
  mb: 1,
};

export const testimonialSectionHeadline: SxProps<Theme> = {
  color: "white",
  fontSize: { xs: "2rem", md: "3rem" },
  fontWeight: 700,
  fontFamily: "'Poppins', sans-serif",
  letterSpacing: "-0.03em",
  lineHeight: 1.1,
  textShadow: "0 4px 24px rgba(0,0,0,0.6)",
  mb: 1.5,
};

export const testimonialFeaturedLabel: SxProps<Theme> = {
  color: "white",
  fontWeight: 700,
  fontSize: { xs: "1rem", md: "1.15rem" },
  letterSpacing: "0.04em",
  textTransform: "uppercase",
  lineHeight: 1.3,
};

export const testimonialFeaturedDescription: SxProps<Theme> = {
  color: "rgba(255,255,255,0.75)",
  fontSize: { xs: "0.82rem", md: "0.9rem" },
  letterSpacing: "0.01em",
  lineHeight: 1.55,
  mt: 0.75,
  maxWidth: 420,
};

export const testimonialThumbnailColumn: SxProps<Theme> = {
  position: "absolute",
  bottom: { xs: 24, md: 40 },
  right: { xs: 16, md: 40 },
  display: "flex",
  flexDirection: "column",
  gap: 1.5,
};

export const testimonialThumbnail: SxProps<Theme> = {
  position: "relative",
  width: { xs: 160, md: 270 },
  height: { xs: 100, md: 165 },
  borderRadius: "10px",
  overflow: "hidden",
  cursor: "pointer",
  opacity: 0.55,
  border: "1.5px solid rgba(255,255,255,0.12)",
  boxShadow: "0 8px 32px rgba(0,0,0,0.5)",
  transition: "opacity 0.3s ease, transform 0.3s ease, border-color 0.3s ease",
  "&:hover": {
    opacity: 1,
    transform: "scale(1.04)",
    borderColor: "rgba(255,255,255,0.4)",
  },
  "&:hover .thumb-play": { opacity: 1 },
};

export const testimonialThumbPlayOverlay: SxProps<Theme> = {
  position: "absolute",
  inset: 0,
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  opacity: 0,
  transition: "opacity 0.3s ease",
};

export const testimonialThumbPlayButton: SxProps<Theme> = {
  width: 36,
  height: 36,
  borderRadius: "50%",
  border: "1.5px solid rgba(255,255,255,0.8)",
  backdropFilter: "blur(6px)",
  backgroundColor: "rgba(255,255,255,0.12)",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
};

export const testimonialThumbLabel: SxProps<Theme> = {
  color: "white",
  fontWeight: 700,
  fontSize: "0.68rem",
  letterSpacing: "0.04em",
  textTransform: "uppercase",
  lineHeight: 1.3,
};

export const ctaSection: SxProps<Theme> = {
  py: { xs: 16, md: 24 },
  minHeight: { xs: "60vh", md: "75vh" },
  display: "flex",
  alignItems: "center",
  textAlign: "center",
  background: "#0a0f1e",
  position: "relative",
  overflow: "hidden",
};

export const ctaOverlay: SxProps<Theme> = {
  position: "absolute",
  inset: 0,
  background: "rgba(8,12,20,0.30)",
  zIndex: 1,
  pointerEvents: "none",
};

export const ctaRadialOverlay: SxProps<Theme> = {
  position: "absolute",
  inset: 0,
  background: "radial-gradient(ellipse 70% 60% at 50% 50%, rgba(0,0,0,0.68) 0%, rgba(0,0,0,0) 75%)",
  zIndex: 1,
  pointerEvents: "none",
};

export const ctaEyebrow: SxProps<Theme> = {
  mb: 3,
  fontSize: { xs: "0.7rem", md: "0.75rem" },
  fontWeight: 600,
  letterSpacing: "0.2em",
  textTransform: "uppercase",
  color: "#38bdf8",
  fontFamily: "'Barlow', sans-serif",
};

export const ctaHeadline: SxProps<Theme> = {
  color: "white",
  mb: 2,
  fontSize: { xs: "2.5rem", md: "3.5rem", lg: "4.5rem" },
  letterSpacing: "-0.02em",
  fontWeight: 800,
  lineHeight: 1.15,
};

export const ctaBody: SxProps<Theme> = {
  color: "rgba(255,255,255,0.82)",
  mb: 5,
  fontWeight: 400,
  fontSize: { xs: "1rem", md: "1.15rem" },
  lineHeight: 1.7,
};

export const dividerLine: SxProps<Theme> = {
  height: "1px",
  background: "linear-gradient(to right, transparent, rgba(255,255,255,0.05), transparent)",
};

export const socialProofSymbol: SxProps<Theme> = {
  position: "absolute",
  top: "50%",
  left: "50%",
  width: { xs: "70vw", md: "50vw" },
  userSelect: "none",
  pointerEvents: "none",
  zIndex: 0,
  filter: "grayscale(1)",
};
